var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleIllus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 47,
    viewBox: "0 0 202 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_28783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.985 33.9862C199.615 33.9862 217.971 15.6405 217.971 -6.99909C217.971 -29.6387 199.625 -47.9844 176.985 -47.9844C154.346 -47.9844 136 -29.6387 136 -6.99911C136 15.6405 154.346 33.9862 176.985 33.9862Z",
    fill: "#19D89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2179 -64.4798C81.2179 15.8923 146.608 81.2828 226.98 81.2723L226.98 162.491C101.82 162.491 -0.000439342 60.6699 -0.000411987 -64.4903L81.2283 -64.4903L81.2179 -64.4798Z",
    fill: "#5959EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_28783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIllus);
export default __webpack_public_path__ + "static/media/circleIllus.e73d89db.svg";
export { ForwardRef as ReactComponent };